const config = {
  apiBaseURL: "https://apis.movierulz31.com",
  appName: "Movierulz",
  homeTitle: `Movierulz – Download Latest Hollywood, Bollywood, Web Series & Regional Movies in HD Free`,
  homeDescription: `Movierulz lets you watch and download the latest Hollywood, Bollywood, and regional movies and web series in full HD for free. Explore trending releases, popular films, and your favorite shows—all in one place`,
  cryptoKey: "OlyNetHOsiAThEvoLYmEStICenCEsTERSONKanteAheRYtOnTr",
  domain: "https://www.movierulz31.com",
  email: `mirzaghalib2026@proton.me`,
};

export default config;
